import React from 'react';
import withIcon from '../utilities/withIcon';

const IconLogoWhatsApp = () => {
  return (
    <g>
      <path d="M8.103 0a7.883 7.883 0 0 1 6.838 3.891 7.739 7.739 0 0 1 0 7.815 7.883 7.883 0 0 1-6.838 3.891 8.033 8.033 0 0 1-3.791-.963L0 16l1.376-4.153A8.934 8.934 0 0 1 .234 7.799C.234 3.492 3.757 0 8.103 0zm0 1.248c-3.65 0-6.61 2.933-6.61 6.55a7.403 7.403 0 0 0 1.288 3.887l-.806 2.385 2.485-.804a7.271 7.271 0 0 0 3.643 1.084c3.65 0 6.61-2.933 6.61-6.551 0-3.618-2.96-6.551-6.61-6.551zM6.049 4.27c.109.025.198.1.243.2.077.172.6 1.39.638 1.483a.51.51 0 0 1-.022.534c-.163.208-.503.597-.503.597a.239.239 0 0 0-.018.312c.294.478.652.916 1.064 1.3a5.08 5.08 0 0 0 1.523.935c.328.106.4-.036.525-.196l.167-.211.139-.174.21-.265a.31.31 0 0 1 .4-.076c.1.045.344.16.61.287l.267.128.678.324c.096.02.165.103.166.2.078.43-.051.872-.35 1.194-.52.478-1.23.7-1.931.6a7.592 7.592 0 0 1-3.041-1.47A9.905 9.905 0 0 1 4.64 7.317a2.549 2.549 0 0 1-.298-1.363 2.15 2.15 0 0 1 .763-1.551.927.927 0 0 1 .324-.134z" />
    </g>
  );
};

export default withIcon(IconLogoWhatsApp);
